module.exports = __webpack_public_path__ + "static/media/header-luck.e9a4a051.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/couponspa/header-luck.png
// module id = 197
// module chunks = 6